import { apiClient } from '@/lib/api/api-client'

import type {
  MeetingRecorderReadinessType,
  MeetingRecordingConsentStatusType,
  MeetingRecordingConsentSurface,
} from '@scrambl/shared'
import { MEETING_RECORDING_CONSENT_VERSION } from '@scrambl/shared'

/** Recorder pre-flight + consent (NOT plan-gated, so Free/Core orgs get a
 *  neutral locked state instead of a 403). */
export class MeetingRecorderApi {
  private static instance: MeetingRecorderApi | null = null

  static getInstance() {
    return (this.instance ??= new MeetingRecorderApi())
  }

  async getReadiness(): Promise<MeetingRecorderReadinessType> {
    return apiClient<MeetingRecorderReadinessType>(
      '/meeting-recorder/readiness',
    )
  }

  async acknowledgeConsent(
    surface: MeetingRecordingConsentSurface,
  ): Promise<MeetingRecordingConsentStatusType> {
    return apiClient<MeetingRecordingConsentStatusType>(
      '/meeting-recorder/consent',
      {
        method: 'POST',
        body: { version: MEETING_RECORDING_CONSENT_VERSION, surface },
      },
    )
  }
}

export const meetingRecorderApi = MeetingRecorderApi.getInstance()
